export const EXERCISE_PLAYING = "EXERCISE_PLAYING";
export const EXERCISE_IDLE = "EXERCISE_IDLE";
export const LAB_ID = 3;
